import React from "react";
import Footer_En from './Footer_En'
import NaviBarv2_En from './NaviBarv2_En'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import {Container, Row, Col, Card, ListGroup, ListGroupItem, Button, Tab, Nav,
OverlayTrigger, Popover, Placeholder} from 'react-bootstrap';


export function Krivorotko_Zvonareva_teaching_En () {
  return (
        <>
    <NaviBarv2_En />
    <Container>
      <section>
        <div class="row my-4 text-center"><h1>Seminars of the course "Vector and tensor analysis"</h1></div>

<div class="row my-4 ps-4"><p class="lead">A course at <a rel="noopener" target="_blank" href="https://www.nsu.ru/n/physics-department/departments/kafedra-vysshey-matematiki/">the Department of Higher Mathematics</a> of Novosibirsk State University for 3rd year students.</p></div>
<div class="row my-4 ps-4"><p class="lead">Authors: <a rel="noopener" target="_blank" href="/Krivorotko_info/En">O. Krivorotko</a>, <a rel="noopener" target="_blank" href="/Zvonareva_info/En">T. Zvonareva</a>.</p></div>
<div class="row my-4 ps-4"><p class="lead">Training manuals: <br></br><a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Криворотько_О_И_,_Звонарева_Т_А_Учебно_методическое_пособие_Векторный.pdf">O. Krivorotko, T. Zvonareva Educational and methodical manual Vector and tensor analysis. NSU, 2021</a>.<br></br> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Аюпова_Н_Б_Лекции_по_векторному_и_тензорному_анализу.pdf">Ayupova N.B. Lectures on vector and tensor analysis. NSU, 2012</a>.</p></div>

       <div class="row my-4 ps-4"><p class="lead">The following is the content of the seminars, the links in the title of the topics lead to the seminar files in pdf format.</p></div>
       <div class="row my-4 ps-4"><p class="lead"><b>1.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинары 1-2.pdf">Tensor, tensor transformations. The main axes and the main values of the tensor. Invariants.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>2.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинар 3.pdf">Symmetrization and antisymmetrization.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>3.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинар 4.pdf">Non-orthogonal bases and the general definition of a tensor. Tensor operations: addition, product, convolution, symmetry and antisymmetry.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>4.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинары 5-6.pdf">The metric tensor. Basic concepts and properties.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>5.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинар 7.pdf">Tensor fields. Curved coordinate systems. Lame coefficients.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>6.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинары 8-9.pdf">Tensor fields. Curved coordinate systems and tensor transformation. Gradient, divergence of the vector field, Laplacian, rotor.</a></p></div>

       <div class="row my-4 ps-4"><p class="lead"><b>7.</b> <a rel="noopener" target="_blank" href="https://ai-biolab.ru/data/Семинар 10-12.pdf">The concept of geodetic lines. Christoffel symbols and their properties. The covariant derivative.</a></p></div>

</section>
        </Container>
        

    <Footer_En />
    </>
    
    )}